/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_Title_PlaceholderInputs */

const vi_withdrawal_title_placeholder = /** @type {(inputs: Withdrawal_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: Lấy hàng đóng gói sáng 26/7`)
};

/**

* @param {Withdrawal_Title_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const withdrawal_title_placeholder = /** @type {((inputs?: Withdrawal_Title_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Title_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_withdrawal_title_placeholder(inputs)
});